// extracted by mini-css-extract-plugin
export var childrenContainer = "_dg-0";
export var virtualScrollArea = "_dg-1";